export default __webpack_public_path__ + "static/media/users.da2e9cd8.svg";